import PropTypes from 'prop-types';

export const handler = PropTypes.func;
export const flag = PropTypes.bool;
export const url = PropTypes.string;

export const barber = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
});

export const fields = PropTypes.object;

export const payrollKindShape = PropTypes.oneOf(['commissionSplits', 'dailyPayroll']);

export const tierKeyNameShape = PropTypes.oneOf(['commissionTiers', 'productCommissionTiers']);
export const commissionTierType = PropTypes.oneOf(['commissionTiers', 'productCommissionTiers']);
